import {css} from '@emotion/react';
import styled from '@emotion/styled';

export const ControlBar = styled.div(({theme}) => {
  return css`
    padding: 12px var(--layout-container-padding);
    background-color: ${theme.colors.backgroundBrand};
  `;
});
